import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { SortDirection } from "../../../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { AccountTransfersCollection } from "../../../../../../../Wrap/Models/Domains/Transactions/AccountTransfers/AccountTransfersCollection";
import { AccountTransfersSort } from "../../../../../../../Wrap/Models/Domains/Transactions/AccountTransfers/AccountTransfersSort";
import { CashTransactionTypes } from "../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashTransactionTypes";
import { CashTransactionCollection } from "../../../../../../../Wrap/Models/Domains/Transactions/CashTransactionCollection";
import { ChargesQuerySort } from "../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesQuerySort";
import { ChargesQueryType } from "../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesQueryType";
import { CorporateActionsCollection } from "../../../../../../../Wrap/Models/Domains/Transactions/CorporateAction/CorporateActionsCollection";
import { InvestmentTransactionCollection } from "../../../../../../../Wrap/Models/Domains/Transactions/Investments/InvestmentTransactionCollection";
import { TransactionSummarryCollection } from "../../../../../../../Wrap/Models/Domains/Transactions/Summary/TransactionSummarryCollection";
import { CashPayment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { CashPaymentFrequencyQuery } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPaymentTypeQuery } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { DateRange } from "../../../../../../Shared/Components/DateRange";
import { PermissionAction } from "../../../../../../Shared/Permission/Action/PermissionAction";
import { Permission } from "../../../../../../Shared/Permission/Permission";
import { sortDirection } from "../../../../../../Shared/Table/Table";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { UserStore } from "../../../../../Stroes/Variable";
import { BondRegularPaymentAction } from "./Actions/BondRegularPaymentAction";
import { BondRegularPaymentStore } from "../../Store/Variables";
import { AccountTransfers } from "./AccountTransfer/AccountTransfers";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../Store/Variable";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeletonWrapper } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeletonWrapper";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { PresentationViewButton } from "../Common/PresentationViewButton";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { orderHeadAccountGroupByInvestorType, selectedHeadAccounts } from "../Common/PortfolioDashboardHelper";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { setActionMenuParams } from "../../../../../../DLU/DLUHelper";
import { SideMenu } from "../../../../../../../Wrap/Constants/Enums/Menu/SideMenu";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { Urls } from "../../../../../Urls";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { DateOptions } from "../../../../../../Shared/Components/Resource/Contents";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import { TransactionAction } from "./Actions/TransactionActions";
import { Cash } from "./Cash/Cash";
import { Charges } from "./Charges/Charges";
import { AdvancedSearch } from "./Components/AdvancedSearch";
import { CorporateActions } from "./CorporateActions/CorporateActions";
import { Investments } from "./Investments/Investments";
import { PaymentsWithdrawals } from "./PaymentsWithdrawals/PaymentsWithdrawals";
import {
    TransactionEnum,
    TransactionEnumArray,
    UnModelTypeOptions,
    CashUnModelTypeOptions,
    SortNameEnum,
    cashPaymentTypeArray,
    cashPaymentTypeMap,
    chargesQueryTypeArray,
    chargesQueryTypeMap,
    cashPaymentFrequencyArray,
    cashPaymentFrequencyMap,
} from "./Resource/Contents";
import { TransactionStore } from "./Store/Variable";
import { TransactionsSummary } from "./Summary/Summary";

interface IPortfolioDashboardTransactionsState {
    userInfo: User;
    transactionType: TransactionEnum;
    from: Date;
    to: Date;
    cashPaymentType: CashPaymentTypeQuery;
    cashPaymentFrequency: CashPaymentFrequencyQuery;
    dateSelected: string;
    isLoading: boolean;
    fromInception: boolean;
    chargeType: ChargesQueryType;
    instrumentCode: string;
    investmentInstrumentCode: string;
    transSource: string;
    modelId: number;
    isPartialLoading: boolean;
    data: {
        [TransactionEnum.summary]: TransactionSummarryCollection;
        [TransactionEnum.accountTransfers]: AccountTransfersCollection;
        [TransactionEnum.corporateActions]: CorporateActionsCollection;
        [TransactionEnum.otherCorporateActions]: CorporateActionsCollection;
        [TransactionEnum.paymentsWithdrawals]: CashPayment[];
        [TransactionEnum.investments]: InvestmentTransactionCollection;
        [TransactionEnum.cash]: CashTransactionCollection;
        [TransactionEnum.charges]: CashPayment[];
    };
    bondPayments?: any;
    allAccounts: ClientAccount[];
    headAccountSelected: string;
    subAccountSelected: string;
    subAccountTypeSelected: SubAccountType;
}

interface IPortfolioDashboardTransactionsProps extends IPortfolioDashboardComponentProps {}

export class PortfolioDashboardTransactions extends PortfolioDashboardComponent<
    IPortfolioDashboardTransactionsProps,
    IPortfolioDashboardTransactionsState
> {
    constructor(props: IPortfolioDashboardTransactionsProps) {
        super(props);

        this.subscribeToStore(TransactionStore, () => this.onTransactionStoreChange());
        this.subscribeToStore(BondRegularPaymentStore, () => this.onBondStoreChange());
    }

    initState() {
        const parameters = getQueryParameters();
        const initDateRange = DateRange.initializeDateRange(this.getSelectedAccountsInceptionDate());

        this.state = {
            userInfo: UserStore.getUserInfo(),
            transactionType:
                parameters["transtypeselect"] != null
                    ? (decodeURI(parameters["transtypeselect"]) as TransactionEnum)
                    : parameters["view"] == null || TransactionEnumArray[parameters["view"]] == null
                    ? PermissionAction.getTransactionDropdownOptions().includes(TransactionEnum.summary)
                        ? TransactionEnum.summary
                        : PermissionAction.getTransactionDropdownOptions()[0]
                    : TransactionEnumArray[parameters["view"]],
            from: parameters["from"] ? new Date(decodeURI(parameters["from"])) : initDateRange.from,
            to: parameters["to"] ? new Date(decodeURI(parameters["to"])) : initDateRange.to,
            dateSelected: parameters["dateSelected"] ? parameters["dateselected"] : initDateRange.dateSelected,
            isLoading: false,
            chargeType: ChargesQueryType.All,
            isPartialLoading: true,
            cashPaymentType: CashPaymentTypeQuery.All,
            cashPaymentFrequency: CashPaymentFrequencyQuery.All,
            fromInception: parameters["fromInception"] || initDateRange.fromInception,
            instrumentCode: null,
            investmentInstrumentCode: parameters["investmentinstrumentcode"],
            transSource: UnModelTypeOptions[0].key,
            modelId: 0,
            data: null,
            bondPayments: null,
            allAccounts: [],
            headAccountSelected: null,
            subAccountSelected: null,
            subAccountTypeSelected: SubAccountType.NotSpecified,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Transactions
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Transactions,
                this.props.isBtnPresentationClicked
            );
            this.setState({ transactionType: TransactionEnum.summary });
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .transactions.getUrl(),
                    pageTitle: `${document.title} - client - transactions`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    getData(selectedSubAccountHierarchyIds: string[]) {
        const allAccounts = orderHeadAccountGroupByInvestorType(PortfolioDashboardStore.getData());
        const multiSelection = selectedSubAccountHierarchyIds;
        const selectedHeadAccountsArray = selectedHeadAccounts(multiSelection, allAccounts);
        const urlHierarchyId = getQueryParameters()["hierarchyid"];
        const { entityId, hierarchyLevel } = HierarchyIdHelper.generateHierarchyId(urlHierarchyId);
        let headAccountSelected,
            subAccountSelected = null,
            subAccountTypeSelected = SubAccountType.NotSpecified;
        if (hierarchyLevel === HierarchyLevelName.Account) {
            headAccountSelected = urlHierarchyId;
            subAccountSelected = urlHierarchyId;
        } else if (hierarchyLevel === HierarchyLevelName.SubAccount) {
            allAccounts.forEach((x) => {
                const subAccounts = x.SubAccounts.filter((s) => s.HierarchyId == urlHierarchyId);
                if (subAccounts.length) {
                    headAccountSelected = x.HierarchyId;
                    subAccountTypeSelected = subAccounts[0].SubAccountType;
                    return;
                }
            });
            subAccountSelected = urlHierarchyId;
        } else {
            //default set as the first head account
            headAccountSelected = selectedHeadAccountsArray[0]?.HierarchyId;
            const allSubAccounts =
                selectedHeadAccountsArray.find((o) => o.HierarchyId == selectedHeadAccountsArray[0]?.HierarchyId)
                    ?.SubAccounts || [];
            const subAccounts = allSubAccounts.filter((ele) => multiSelection.includes(ele.HierarchyId));
            let _sub = selectedHeadAccountsArray[0]?.HierarchyId;
            if (allSubAccounts.length !== subAccounts.length) {
                _sub = subAccounts?.[0].HierarchyId;
                subAccountTypeSelected = subAccounts?.[0].SubAccountType;
            }
            subAccountSelected = _sub;
        }

        const { minDate } = DateRange.getLeastDate(subAccountSelected);
        const initDateRange = DateRange.initializeDateRange(minDate);
        this.setState(
            {
                allAccounts: selectedHeadAccountsArray,
                headAccountSelected: headAccountSelected,
                subAccountSelected: subAccountSelected,
                subAccountTypeSelected: subAccountTypeSelected,
                from: initDateRange.from,
                to: initDateRange.to,
                dateSelected: initDateRange.dateSelected,
                fromInception: initDateRange.fromInception,
            },
            () => this.getTransactionData()
        );
    }

    private getSubAccountData(key, Options: any[], isTxt: boolean) {
        let val;
        for (let i = 0; i < Options.length; i++) {
            if (Options[i].key === key) {
                val = isTxt ? Options[i].value : Options[i].type;
                return val;
            }
        }
        return val;
    }

    private getTransactionData() {
        const { transactionType } = this.state;
        switch (transactionType) {
            case TransactionEnum.summary:
                this.setState({ isLoading: true });
                this.getSummary();
                break;
            case TransactionEnum.cash:
                this.setState({ isLoading: true });
                this.getCashTransactions(0, CashUnModelTypeOptions[0].key, SortDirection.Descending, 1, 10);
                break;
            case TransactionEnum.investments:
                this.setState({ isLoading: true, isPartialLoading: true });
                this.getInvestmentTransactions(
                    0,
                    UnModelTypeOptions[0].key,
                    SortNameEnum.AsAt,
                    sortDirection.DESC,
                    1,
                    10
                );
                break;
            case TransactionEnum.corporateActions:
                this.setState({ isLoading: true });
                this.getCorporateActions("Dividend", SortNameEnum.ExDate, sortDirection.DESC, 1, 10);
                break;
            case TransactionEnum.otherCorporateActions:
                this.setState({ isLoading: true });
                this.getCorporateActions(null, SortNameEnum.ExDate, sortDirection.DESC, 1, 10);
                break;
            case TransactionEnum.paymentsWithdrawals:
                this.setState({ isLoading: true });
                this.getPaymentsWithdrawals();
                break;
            case TransactionEnum.accountTransfers:
                this.setState({ isLoading: true });
                this.getAccountTransfers(AccountTransfersSort.Date, false, 1, 10);
                break;
            case TransactionEnum.charges:
                this.setState({ isLoading: true });
                this.getCharges(ChargesQuerySort.Date, false);
                break;
            default:
                return null;
        }
    }

    private onTransactionStoreChange() {
        const data = TransactionStore.getData();
        if (data && data[this.state.transactionType])
            {this.setState({ isLoading: false, data, isPartialLoading: false });}
    }

    private onBondStoreChange(): void {
        const data = BondRegularPaymentStore.getData();
        this.setState({ bondPayments: data });
    }

    private getInvestmentTransactions = (
        modelId: number,
        transSource: string,
        sortName: SortNameEnum,
        sortDirection: sortDirection,
        minRow: number,
        maxRow: number,
        newHierarchyId?: string,
        cNoteId?: number,
        investmentInstrumentCode?: string
    ) => {
        const { subAccountSelected, from, to } = this.state;
        const hierarchyId = newHierarchyId ? newHierarchyId : subAccountSelected;
        const security =
            investmentInstrumentCode != null ? investmentInstrumentCode : this.state.investmentInstrumentCode || "";
        const noteId = cNoteId ? cNoteId : 0;
        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            TransactionAction.getInvestmentTransactions(
                hierarchyId,
                from,
                to,
                noteId,
                security,
                transSource,
                sortName,
                sortDirection.toString(),
                modelId,
                minRow,
                maxRow
            );
        }
    };

    private getCashTransactions = (
        modelId: number,
        transactionType: CashTransactionTypes,
        sortDirection: SortDirection,
        minRow: number,
        maxRow: number
    ) => {
        const { subAccountSelected, from, to, fromInception } = this.state;
        const hierarchyId = subAccountSelected;
        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            TransactionAction.getCashTransactions(
                hierarchyId,
                from,
                to,
                fromInception,
                transactionType as any,
                modelId,
                sortDirection,
                minRow,
                maxRow
            );
        }
    };

    private getSummary = () => {
        const { subAccountSelected, from, to, fromInception } = this.state;
        if (!CommonHelper.isNullOrEmpty(subAccountSelected)) {
            TransactionAction.getSummaryTransactions(subAccountSelected, from, to, fromInception);
        }
    };

    private getAccountTransfers = (
        sortBy: AccountTransfersSort,
        orderByAESC: boolean,
        minrow: number,
        maxrow: number
    ) => {
        const { subAccountSelected, from, to, fromInception } = this.state;
        if (!CommonHelper.isNullOrEmpty(subAccountSelected)) {
            TransactionAction.getAccountTransfer(
                subAccountSelected,
                from,
                to,
                fromInception,
                minrow,
                maxrow,
                sortBy,
                orderByAESC
            );
        }
    };

    private getCorporateActions = (
        corpActionType: string,
        sortName: SortNameEnum,
        sortDirection: sortDirection,
        minRow: number,
        maxRow: number
    ) => {
        const { subAccountSelected, from, to, fromInception, data, instrumentCode } = this.state;
        if (!CommonHelper.isNullOrEmpty(subAccountSelected)) {
            if (corpActionType == "Dividend")
                {TransactionAction.getDividendSummary(
                    subAccountSelected,
                    from,
                    to,
                    fromInception,
                    instrumentCode,
                    corpActionType,
                    sortName,
                    sortDirection.toString(),
                    minRow,
                    maxRow
                );}
            else
                {TransactionAction.getOtherCorporateActions(
                    subAccountSelected,
                    from,
                    to,
                    fromInception,
                    instrumentCode,
                    corpActionType,
                    sortName,
                    sortDirection.toString(),
                    minRow,
                    maxRow
                );}
        }
    };

    private getCharges = (sortBy: ChargesQuerySort, orderByAESC: boolean) => {
        const { subAccountSelected, from, to, fromInception, chargeType } = this.state;
        if (!CommonHelper.isNullOrEmpty(subAccountSelected)) {
            TransactionAction.getCharges(subAccountSelected, from, to, fromInception, chargeType, sortBy, orderByAESC);
        }
    };

    private getPaymentsWithdrawals() {
        const {
            subAccountSelected,
            from,
            to,
            fromInception,
            cashPaymentFrequency,
            cashPaymentType,
            subAccountTypeSelected,
        } = this.state;
        if (!CommonHelper.isNullOrEmpty(subAccountSelected)) {
            TransactionAction.getPaymentWithdrawals(
                subAccountSelected,
                from,
                to,
                fromInception,
                cashPaymentType,
                cashPaymentFrequency
            );
            if (
                subAccountTypeSelected == SubAccountType.OnshoreBond ||
                subAccountTypeSelected == SubAccountType.OffshoreBond ||
                subAccountTypeSelected == SubAccountType.NotSpecified
            ) {
                BondRegularPaymentAction.getBondRegularPayment(subAccountSelected);
            }
        }
    }

    private showSelectedOption = (transactionType: TransactionEnum) => {
        const { data, subAccountSelected, isPartialLoading, from, to, fromInception } = this.state;
        switch (transactionType) {
            case TransactionEnum.summary:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalInvestmentTransactionCanView}>
                        <TransactionsSummary
                            data={data ? data[TransactionEnum.summary] : null}
                            from={from}
                            to={to}
                            onTableChange={() => {
                                this.getSummary();
                            }}
                        />
                    </Permission>
                );
            case TransactionEnum.cash:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalInvestmentTransactionCanView}>
                        <Cash
                            hierarchyId={subAccountSelected}
                            data={data ? data[TransactionEnum.cash] : null}
                            fromDate={from}
                            toDate={to}
                            fromInception={fromInception}
                            cashTransactionType={getQueryParameters()["cashTransactionType"]}
                            onTableChange={(transSource, modelId, sortDirection, minRow, maxRow) => {
                                this.getCashTransactions(modelId, transSource, sortDirection, minRow, maxRow);
                                this.setState({
                                    transSource: transSource,
                                    modelId: modelId,
                                });
                            }}
                        />
                    </Permission>
                );
            case TransactionEnum.investments:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalInvestmentTransactionCanView}>
                        <Investments
                            isLoading={isPartialLoading}
                            hierarchyId={subAccountSelected}
                            instrucmentCode={this.state.investmentInstrumentCode}
                            data={data ? data[TransactionEnum.investments] : null}
                            fromDate={this.state.from}
                            toDate={this.state.to}
                            onTableChange={(
                                transSource,
                                modelId,
                                sortName,
                                sortDirection,
                                minRow,
                                maxRow,
                                newHierarchyId,
                                cNoteId,
                                investmentInstrumentCode
                            ) => {
                                this.getInvestmentTransactions(
                                    modelId,
                                    transSource,
                                    sortName,
                                    sortDirection,
                                    minRow,
                                    maxRow,
                                    newHierarchyId,
                                    cNoteId,
                                    investmentInstrumentCode
                                );
                                this.setState({
                                    transSource: transSource,
                                    modelId: modelId,
                                    isPartialLoading: true,
                                    investmentInstrumentCode: investmentInstrumentCode,
                                });
                            }}
                        />
                    </Permission>
                );
            case TransactionEnum.paymentsWithdrawals:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalPaymentsAndWithdrawlsCanView}>
                        <PaymentsWithdrawals
                            data={data ? data[TransactionEnum.paymentsWithdrawals] : null}
                            selectAccount={DateRange.getLeastDate(this.state.subAccountSelected).wpAccount}
                            frequency={this.state.cashPaymentFrequency}
                            subAccountTypeSelected={this.state.subAccountTypeSelected}
                            bondPayments={this.getList()}
                            onTableChange={() => {
                                this.getPaymentsWithdrawals();
                            }}
                        />
                    </Permission>
                );
            case TransactionEnum.accountTransfers:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalAccountTransfersCanView}>
                        <AccountTransfers
                            data={data ? data[TransactionEnum.accountTransfers] : null}
                            onTableChange={(sortBy, orderBy, min, max) => {
                                this.getAccountTransfers(sortBy, orderBy, min, max);
                            }}
                        />
                    </Permission>
                );
            case TransactionEnum.corporateActions:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalDividendSummaryCanView}>
                        <CorporateActions
                            corpActionType={"Dividend"}
                            data={data ? data[TransactionEnum.corporateActions] : null}
                            onTableChange={(sortName, sortDirection, minRow, maxRow) =>
                                this.getCorporateActions("Dividend", sortName, sortDirection, minRow, maxRow)
                            }
                            selectedSubAccount={subAccountSelected}
                        />
                    </Permission>
                );
            case TransactionEnum.otherCorporateActions:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalOtherCorporateActionsCanView}>
                        <CorporateActions
                            data={data ? data[TransactionEnum.otherCorporateActions] : null}
                            onTableChange={(sortName, sortDirection, minRow, maxRow) =>
                                this.getCorporateActions(null, sortName, sortDirection, minRow, maxRow)
                            }
                            selectedSubAccount={subAccountSelected}
                        />
                    </Permission>
                );
            case TransactionEnum.charges:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalPerformanceChargesCanView}>
                        <Charges
                            data={data ? data[TransactionEnum.charges] : null}
                            onTableChange={(sortBy, orderBy) => {
                                this.getCharges(sortBy, orderBy);
                            }}
                        />
                    </Permission>
                );
            default:
                return null;
        }
    };

    private findInvestment(instrumentCode) {
        const { transactionType } = this.state;
        let corpActionType = null;
        if (transactionType == TransactionEnum.corporateActions) {
            corpActionType = "Dividend";
        }
        this.setState({ instrumentCode: instrumentCode }, () => {
            this.getCorporateActions(corpActionType, SortNameEnum.ExDate, sortDirection.DESC, 1, 10);
        });
    }

    private getList() {
        const { bondPayments } = this.state;
        const list = new Array<any>();
        bondPayments?.forEach((element) => {
            element.Payments.forEach((sub) => {
                list.push(sub);
            });
        });
        return list;
    }

    private handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const { headAccountSelected, subAccountSelected } = this.state;

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {context.customerId = customerHierarchyId;}
        if (headAccountSelected) {context.accountGroupId = headAccountSelected;}
        // handle scenario of head account selected
        if (subAccountSelected && headAccountSelected !== subAccountSelected) {context.accountId = subAccountSelected;}

        (window as any).AppStore.open(context);
    }

    private getSelectedClaccountID(): string {
        const data = PortfolioDashboardStore.getData();
        const { allAccounts, subAccountSelected, headAccountSelected } = this.state;
        const { hierarchyLevel } = HierarchyIdHelper.generateHierarchyId(subAccountSelected);
        if (allAccounts && allAccounts.length > 0) {
            if (hierarchyLevel == HierarchyLevelName.Account) {
                return (allAccounts || []).find((acc) => acc.HierarchyId == subAccountSelected)?.HeadClAccountId;
            }
            return ((allAccounts || []).find((acc) => acc.HierarchyId == headAccountSelected)?.SubAccounts || []).find(
                (subAcc) => subAcc.HierarchyId == subAccountSelected
            )?.ClAccountId;
        } else {
            return data[0]?.HeadClAccountId;
        }
    }

    render() {
        const {
            from,
            to,
            dateSelected,
            transactionType,
            isLoading,
            headAccountSelected,
            subAccountSelected,
            allAccounts,
        } = this.state;

        const { minDate, isDisable } = DateRange.getLeastDate(subAccountSelected);
        const { isPresentationView } = this.context;

        const subaccountViewDic: any[] = [];

        const allSubAccounts = allAccounts.find((o) => o.HierarchyId == headAccountSelected)?.SubAccounts || [];
        const subAccounts = allSubAccounts.filter((ele) =>
            PortfolioDashboardMultiSelectionStore.getData().includes(ele.HierarchyId)
        );
        if (allSubAccounts.length == subAccounts.length) {
            subaccountViewDic.push({ key: headAccountSelected, value: "Portfolio view" });
        }
        subAccounts?.forEach((item) => {
            const accoutNum = " " + item.ClAccountId.substr(item.ClAccountId.indexOf("-") + 1);
            const _value = item.ProductDisplayName + accoutNum;
            subaccountViewDic.push({ key: item.HierarchyId, value: _value, type: item.SubAccountType });
        });

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;

        return (
            <div role={isPresentationView ? "main" : "tabpanel"} id="panel-4" tabIndex={0} aria-labelledby="tab-4">
                <div className="ad d1">
                    <Alert
                        alertType={AlertType.Warning}
                        message={"Please note that only 1 account can be selected at a time on this page."}
                    />
                    <div className="row narrow-gutter">
                        <div className="col-12 col-sm-6">
                            <SelectEditor
                                key="HeadAccountView"
                                label="Select account"
                                selected={headAccountSelected}
                                options={allAccounts.map((x) => x.HierarchyId)}
                                getText={(x) => {
                                    const account = allAccounts.find((o) => o.HierarchyId == x);
                                    return `${account?.AccountName} ${account?.HeadClAccountId}`;
                                }}
                                onChange={(val) => {
                                    const minDate = DateRange.getLeastDate(val).minDate;
                                    const dateRange = DateRange.initializeDateRange(minDate);

                                    const allSubAccounts =
                                        allAccounts.find((o) => o.HierarchyId == val)?.SubAccounts || [];
                                    const subAccounts = allSubAccounts.filter((ele) =>
                                        PortfolioDashboardMultiSelectionStore.getData().includes(ele.HierarchyId)
                                    );
                                    let _sub = val;
                                    let subAccountTypeSelected = SubAccountType.NotSpecified;
                                    if (allSubAccounts.length !== subAccounts.length) {
                                        _sub = subAccounts?.[0].HierarchyId;
                                        subAccountTypeSelected = subAccounts?.[0].SubAccountType;
                                    }
                                    this.addEvent({
                                        event: "transactionstab_interaction",
                                        eventParameters: {
                                            eventAction: "interactions",
                                            eventCategory: eventCategoryForGTM.transactionsTab,
                                            eventLabel: `select account`,
                                        },
                                    });
                                    this.setState(
                                        {
                                            headAccountSelected: val,
                                            subAccountSelected: _sub,
                                            subAccountTypeSelected: subAccountTypeSelected,
                                            from: dateRange.from,
                                            to: dateRange.to,
                                            dateSelected: dateRange.dateSelected,
                                            investmentInstrumentCode: "",
                                        },
                                        () => this.getTransactionData()
                                    );
                                }}
                            />
                        </div>
                        {checkPermission(UserClaim.AdviserPortalDluOrdersCanView) && (
                            <div className="col-12 col-sm-6 col-middle col-right mt-21 mb-28">
                                <a
                                    href={`/clients/orders/orders.aspx?claccountid=${this.getSelectedClaccountID()}`}
                                    onClick={() => {
                                        this.addEvent({
                                            event: "transactionstab_interaction",
                                            eventParameters: {
                                                eventAction: "interactions",
                                                eventCategory: eventCategoryForGTM.transactionsTab,
                                                eventLabel: `pending transactions`,
                                            },
                                        });
                                        setActionMenuParams({
                                            levelHierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                HierarchyLevelName.Customer,
                                                this.props.customerid
                                            ),
                                            subaccountHierarchyId: null,
                                            headaccounthierarchyId: this.state.headAccountSelected,
                                            SideMenu: SideMenu.Portfolio,
                                        });
                                    }}
                                    className="hyperlink-next text-size-18"
                                >
                                    Pending transactions
                                </a>
                            </div>
                        )}
                    </div>
                    <div className="row narrow-gutter">
                        <>
                            <div className="col-6 col-lg-3">
                                <SelectEditor
                                    key="SubAccountView"
                                    label="Select view"
                                    selected={subAccountSelected}
                                    options={subaccountViewDic.map((ele) => ele.key)}
                                    getText={(x) => this.getSubAccountData(x, subaccountViewDic, true)}
                                    onChange={(val) => {
                                        const minDate = DateRange.getLeastDate(val).minDate;
                                        const dateRange = DateRange.initializeDateRange(minDate);
                                        const type = this.getSubAccountData(val, subaccountViewDic, false);
                                        this.addEvent({
                                            event: "transactionstab_interaction",
                                            eventParameters: {
                                                eventAction: "view selector",
                                                eventCategory: eventCategoryForGTM.transactionsTab,
                                                eventLabel: this.getSubAccountData(val, subaccountViewDic, true),
                                            },
                                        });
                                        this.setState(
                                            {
                                                subAccountSelected: val,
                                                from: dateRange.from,
                                                to: dateRange.to,
                                                dateSelected: dateRange.dateSelected,
                                                investmentInstrumentCode: "",
                                                subAccountTypeSelected: type,
                                            },
                                            () => this.getTransactionData()
                                        );
                                    }}
                                />
                            </div>
                            {!isPresentationView && (
                                <div className="col-6 col-lg-3">
                                    <SelectEditor
                                        label="Transactions"
                                        selected={transactionType}
                                        options={PermissionAction.getTransactionDropdownOptions()}
                                        getText={(o) => o}
                                        onChange={(e) => {
                                            this.addEvent({
                                                event: "transactionstab_interaction",
                                                eventParameters: {
                                                    eventAction: "transaction type selector",
                                                    eventCategory: eventCategoryForGTM.transactionsTab,
                                                    eventLabel: e.toLowerCase(),
                                                },
                                            });
                                            this.setState({ transactionType: e }, () => this.getTransactionData());
                                        }}
                                    />
                                </div>
                            )}
                            {transactionType !== TransactionEnum.paymentsWithdrawals && (
                                <div className="col-12 col-lg-6">
                                    <DateRange
                                        disabled={isDisable}
                                        minDate={minDate}
                                        fromDate={from}
                                        toDate={to}
                                        cssGridDate="col-12 col-sm-auto"
                                        cssGridTo="col-fluid col-max-180"
                                        cssGridFrom="col-fluid col-max-180"
                                        cssGridLabel="col-12 col-sm-auto col-middle"
                                        selectValue={dateSelected}
                                        onChange={(
                                            fromDate: Date,
                                            toDate: Date,
                                            fromInception: boolean,
                                            dateSelected: string,
                                            isFromAndTo?: boolean
                                        ) => {
                                            this.addEvent({
                                                event: "transactionstab_interaction",
                                                eventParameters: {
                                                    eventAction: "date range selector",
                                                    eventCategory: eventCategoryForGTM.transactionsTab,
                                                    eventLabel: CommonHelper.getOptionsTxt(
                                                        dateSelected,
                                                        DateOptions
                                                    ).toLowerCase(),
                                                },
                                            });
                                            this.setState(
                                                {
                                                    from: fromDate,
                                                    to: toDate,
                                                    dateSelected: dateSelected,
                                                    fromInception: fromInception,
                                                },
                                                () => this.getTransactionData()
                                            );
                                        }}
                                    />
                                </div>
                            )}
                            <div className="col-fluid col-right col-middle">
                                <PresentationViewButton
                                    onClick={() => {
                                        this.addEvent({
                                            event: "transactionstab_interaction",
                                            eventParameters: {
                                                eventAction: "interactions",
                                                eventCategory: eventCategoryForGTM.transactionsTab,
                                                eventLabel: `presentation mode`,
                                            },
                                        });
                                        this.props.onPresentationViewStatusChange(
                                            portfolioDashboardTabEnum.Transactions,
                                            this.props.isBtnPresentationClicked
                                        );
                                    }}
                                />
                                {isAppStoreEnabled && (
                                    <button
                                        type="button"
                                        className="applications-pad-button"
                                        onClick={this.handleLaunchpadClick.bind(this)}
                                    >
                                        <span className="sr-only">Applications pad</span>
                                        <span className="icon" aria-hidden="true"></span>
                                    </button>
                                )}
                            </div>
                        </>
                    </div>
                    <div>
                        {!isPresentationView &&
                            (transactionType == TransactionEnum.charges ||
                                transactionType == TransactionEnum.paymentsWithdrawals) && (
                                <>
                                    <hr className="divider mt-15 mb-30" />
                                    <div className="row narrow-gutter">
                                        <div className="col-12 col-sm-fluid col-max-245">
                                            {transactionType !== TransactionEnum.charges ? (
                                                <SelectEditor
                                                    label="Transaction type"
                                                    options={cashPaymentTypeArray}
                                                    getText={(v) => {
                                                        return cashPaymentTypeMap[v];
                                                    }}
                                                    onChange={(v) => {
                                                        this.addEvent({
                                                            event: "transactionstab_interaction",
                                                            eventParameters: {
                                                                eventAction: "interactions",
                                                                eventCategory: eventCategoryForGTM.transactionsTab,
                                                                eventLabel: `select transaction type`,
                                                            },
                                                        });
                                                        this.setState({ cashPaymentType: v }, () =>
                                                            this.getTransactionData()
                                                        );
                                                    }}
                                                />
                                            ) : (
                                                <SelectEditor
                                                    label="Charge type"
                                                    options={chargesQueryTypeArray}
                                                    getText={(v) => {
                                                        return chargesQueryTypeMap[v];
                                                    }}
                                                    onChange={(v) => {
                                                        this.addEvent({
                                                            event: "transactionstab_interaction",
                                                            eventParameters: {
                                                                eventAction: "interactions",
                                                                eventCategory: eventCategoryForGTM.transactionsTab,
                                                                eventLabel: `select charge type`,
                                                            },
                                                        });
                                                        this.setState({ chargeType: v }, () =>
                                                            this.getTransactionData()
                                                        );
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {transactionType == TransactionEnum.paymentsWithdrawals && (
                                            <div className="col-12 col-sm-fluid col-max-245">
                                                <SelectEditor
                                                    label="Payment frequency"
                                                    options={cashPaymentFrequencyArray}
                                                    getText={(v) => {
                                                        return cashPaymentFrequencyMap[v];
                                                    }}
                                                    onChange={(v) => {
                                                        this.addEvent({
                                                            event: "transactionstab_interaction",
                                                            eventParameters: {
                                                                eventAction: "interactions",
                                                                eventCategory: eventCategoryForGTM.transactionsTab,
                                                                eventLabel: `select payment frequency`,
                                                            },
                                                        });
                                                        this.setState({ cashPaymentFrequency: v }, () =>
                                                            this.getTransactionData()
                                                        );
                                                    }}
                                                />
                                            </div>
                                        )}
                                        {transactionType != TransactionEnum.paymentsWithdrawals &&
                                        transactionType != TransactionEnum.charges ? (
                                            <div className="col-12 col-sm-fluid col-max-245">
                                                {/* <SelectEditor label="MPS Model" options={[{ value: "All" }]} /> */}
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            )}

                        {!isPresentationView && this.renderAdvanceSearch()}
                        <LoadingSkeletonWrapper isLoading={isLoading} skeletonType={LoadingSkeletonType.Table}>
                            {this.showSelectedOption(isPresentationView ? TransactionEnum.summary : transactionType)}
                        </LoadingSkeletonWrapper>
                    </div>
                </div>
            </div>
        );
    }

    private renderAdvanceSearch() {
        const { data, transactionType } = this.state;
        let isCorp = false;
        let isOtherCorp = false;

        if (transactionType == TransactionEnum.corporateActions && data && data[TransactionEnum.corporateActions]) {
            isCorp = data[TransactionEnum.corporateActions].Items.length > 0;
        }
        if (
            transactionType == TransactionEnum.otherCorporateActions &&
            data &&
            data[TransactionEnum.otherCorporateActions]
        ) {
            isOtherCorp = data[TransactionEnum.otherCorporateActions].Items.length > 0;
        }

        if (this.state.instrumentCode != null || isCorp || isOtherCorp) {
            return (
                <div>
                    <AdvancedSearch
                        transactionType={transactionType}
                        onChange={(instrumentCode) => {
                            this.findInvestment(instrumentCode);
                        }}
                    />
                </div>
            );
        }
        return null;
    }
}
PortfolioDashboardTransactions.contextType = PresentationContext;
